import type { AidPreferenceClessDto } from "../../types/AidPreferenceClessDto";
import type { AidPreferenceClessEntity } from "../../types/AidPreferenceClessEntity";

export const AidPreferenceClessDtoToEntity = ({ ...rest }: Readonly<AidPreferenceClessDto>): AidPreferenceClessEntity => {
    return { ...rest };
};
